import { useEffect, useState } from 'react';
import { Observable } from 'rxjs';

function useObservable<T>(observable: Observable<T>, nextValue?: (value: any) => any): [any, any] {
  const [data, setData] = useState();

  useEffect(() => {
    const subscription = observable.subscribe((value: any) => setData(value));
    return () => subscription.unsubscribe();
    /* eslint-disable-next-line */
  }, []);

  const setNextValue = (value: any) => {
    if (nextValue) nextValue(value);
    setData(value);
  };

  return [data, setNextValue];
}

export default useObservable;
